import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { toast } from "sonner";
import { STATUS_KEYS } from "@/lib/reward-tiers";
import { formatDateTime } from "@/lib/date";

export default function StaffReferrals() {
  const { t } = useLang();
  const [refs, setRefs] = useState([]);
  const load = () => api.get("/staff/referrals").then((r) => setRefs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => {
    try {
      await api.patch(`/staff/referrals/${id}/status`, { status });
      toast.success("Status updated");
      load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6">
      <h1 className="font-serif-display text-4xl">{t.admin.referrals}</h1>
      <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
        {refs.length === 0 ? (
          <div className="p-10 text-center text-sm text-white/60">No referrals from your ambassadors yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-widest text-white/50 border-b border-white/10">
              <tr>
                <th className="text-left p-4">Friend</th>
                <th className="text-left p-4">Ambassador</th>
                <th className="text-left p-4">Phone</th>
                <th className="text-left p-4">Source</th>
                <th className="text-left p-4">Added</th>
                <th className="text-left p-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {refs.map((r) => (
                <tr key={r.id} data-testid={`staff-ref-row-${r.id}`} className="border-b border-white/5 last:border-0">
                  <td className="p-4">{r.first_name} {r.last_name}</td>
                  <td className="p-4 text-white/70">{r.ambassador_name}</td>
                  <td className="p-4 text-white/70">{r.phone}</td>
                  <td className="p-4 text-white/70 capitalize">{r.source}</td>
                  <td className="p-4 text-xs text-white/70">{formatDateTime(r.created_at)}</td>
                  <td className="p-4">
                    <select data-testid={`staff-ref-status-${r.id}`} value={r.status} onChange={(e) => changeStatus(r.id, e.target.value)}
                      className="bg-[#0b1521] border border-white/20 rounded-full px-3 py-1.5 text-xs">
                      {STATUS_KEYS.map((s) => <option key={s} value={s}>{t.statuses[s]}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
